import { Component } from 'react'

import PropTypes from 'prop-types'

import { markPageReloading, setLegacyPageMounted } from 'utils/sdks/rumViews'

import BillingContactModal from 'modals/BillingContactModal'
import ReassignConnectionsModal from 'modals/ReassignConnectionsModal/ReassignConnectionsModal'
import ProductDetailModal from 'modals/Shop/ProductDetailModal'
import SkuDeliveryModal from 'modals/Shop/SkuDeliveryModal'
import { PRODUCT_CATALOG } from 'routes/paths'

import { handleShowOnlyProductsContent } from './LegacyPage.utils'
import NewsBanner from 'containers/NewsBanner'
import ConnectionRequestModal from 'features/Connection/modals/ConnectionRequestModal/ConnectionRequestModal'
import { CUSTOMER_DATA_PARAM } from 'features/LeadGen/RetailerProfile/RetailerProfileViewMode/RetailerProfileViewMode'
import ManageImagesModal from 'features/Linesheets/Modals/ManageImagesModal/ManageImagesModal'
import OrderReviewReleaseHeader from 'features/Orders/Review/components/OrderReviewReleaseHeader/OrderReviewReleaseHeader'
import { ProductsEditEvents } from 'features/Orders/Review/modals/ProductsEditModal/components/ProductsEditEvents'
import RetailLinesheetsBanner from 'features/RetailLinesheetsBanner/RetailLinesheetsBanner'

class LegacyPage extends Component {
  componentDidMount() {
    if (this.requestIsFromReact()) {
      this.refreshPage()
    } else {
      window.addEventListener('openModal', this.handleModalFromPHP, false)
      window.addEventListener('openCatalog', this.handleCatalogFromPHP, false)

      this.hideReactNavbar()
      this.showLegacyContent()
      setLegacyPageMounted(true)
    }

    this.props.trackPageView()
  }

  componentDidUpdate(prevProps) {
    if (
      this.isPushAction() ||
      this.hasPageChanged(prevProps.location, this.props.location)
    ) {
      // Refresh the page when going from one legacy page to another one
      this.refreshPage()
    }
  }

  componentWillUnmount() {
    setLegacyPageMounted(false)
  }

  getURLFromLocation = (location) =>
    location.pathname + location.search + location.hash

  handleModalFromPHP = ({ detail }) => {
    const modals = {
      BillingContactModal,
      ConnectionRequestModal,
      ManageImagesModal,
      ProductDetailModal,
      ReassignConnectionsModal,
      SkuDeliveryModal,
    }

    const modalComponent = modals[detail.modalName]
    if (!modalComponent) {
      return
    }

    this.props.openDynamicModal({
      component: modalComponent,
      ...detail,
    })
  }

  handleCatalogFromPHP = ({ detail: { collection, brandId } }) => {
    this.props.navigate({
      pathname: PRODUCT_CATALOG,
      state: { collection, brandId, fromPHP: true },
    })
  }

  pagesHaveHash = (sourceLocation, targetLocation) =>
    sourceLocation.hash && targetLocation.hash

  pagesAreException = (sourceURL, targetURL) => {
    const exceptions = ['#!']
    return exceptions.some(
      (exception) =>
        sourceURL.includes(exception) || targetURL.includes(exception),
    )
  }

  hasPageChanged = (sourceLocation, targetLocation) => {
    // Strip parts of the location from the URLs and compare them to determine
    // whether the page was changed or not.
    // We need to clean the URLs because PHP will sometimes change a URL without
    // taking the user to another page (e.g. selecting linesheets in the shop)
    const regex = /\/?(\d+.*)?(\?.*)?(#.*)/
    const sourceURL = this.getURLFromLocation(sourceLocation)
    const targetURL = this.getURLFromLocation(targetLocation)
    const sourcePath = sourceURL.replace(regex, '')
    const targetPath = targetURL.replace(regex, '')
    const urlHasChanged = sourcePath !== targetPath
    const pagesHaveHash = this.pagesHaveHash(sourceLocation, targetLocation)
    const pagesAreException = this.pagesAreException(sourceURL, targetURL)
    return urlHasChanged && (pagesHaveHash || pagesAreException)
  }

  isPushAction = () => this.props.navigationType === 'PUSH'

  refreshPage = () => {
    // Force browser to refresh the page in order to load the content from PHP
    markPageReloading()
    window.location.reload()
  }

  requestIsFromReact = () => {
    const rootContainer = document.querySelector('body > div.joor-react')
    const previousPageUsedReact =
      rootContainer && rootContainer.classList.contains('react-page')
    return this.isPushAction() || previousPageUsedReact
  }

  showLegacyContent = () => {
    // A <div> with the id "content-overlay" hides all the content of the pages except
    // for the navigation bar.
    // This container is always displayed on top of everything and the following code
    // removes it to reveal the content rendered by PHP.
    const contentOverlay = document.getElementById('content-overlay')
    if (contentOverlay && !window.location.href.includes(CUSTOMER_DATA_PARAM)) {
      contentOverlay.remove()
    }
  }

  hideReactNavbar = () => {
    if (window.location.href.includes(CUSTOMER_DATA_PARAM)) {
      const navbarEmbeddedInPHP = document.querySelector(
        "[data-testid='navbar']",
      )
      if (navbarEmbeddedInPHP) {
        navbarEmbeddedInPHP.style.display = 'none'
      }
    }
  }

  render() {
    handleShowOnlyProductsContent()

    const news = []
    return (
      <>
        <NewsBanner newsToDisplay={news} />
        <ProductsEditEvents />
        <OrderReviewReleaseHeader />
        <RetailLinesheetsBanner />
        {process.env.NODE_ENV === 'test' && <div data-testid="legacy-page" />}
      </>
    )
  }
}

LegacyPage.propTypes = {
  isLiteBrand: PropTypes.bool.isRequired,
  navigate: PropTypes.func.isRequired,
  navigationType: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  openDynamicModal: PropTypes.func,
  trackPageView: PropTypes.func,
}

LegacyPage.defaultProps = {
  openDynamicModal: () => {},
  trackPageView: () => {},
}

export default LegacyPage
